import React from 'react';

import './input-mixin.less';

import Label from './../internal/label.js';
import InputWrapper from './../internal/input-wrapper.js';

const INITIAL_FEEDBACK = 'initial';
const SUCCESS_FEEDBACK = 'success';
const WARNING_FEEDBACK = 'warning';
const ERROR_FEEDBACK = 'error';
const LOADING_FEEDBACK = 'loading';

export const InputMixin = {

  //@@viewOn:mixins
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    UU5_Forms_InputMixin: {
      classNames: {
        main: 'uu5-forms-input',
        formItem: 'uu5-forms-input-form-item',
        input: 'uu5-forms-input-',
        readOnly: 'uu5-forms-input-read-only',
        hasGlyphicon: "uu5-forms-input-glyphicon"
      }
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    label: React.PropTypes.any,
    message: React.PropTypes.any,

    feedback: React.PropTypes.oneOf([INITIAL_FEEDBACK, SUCCESS_FEEDBACK, WARNING_FEEDBACK, ERROR_FEEDBACK, LOADING_FEEDBACK]),

    readOnly: React.PropTypes.bool,

    size: React.PropTypes.oneOf(['lg', 'md', 'sm']),

    onChange: React.PropTypes.func,
    onValidate: React.PropTypes.func,
    onChangeFeedback: React.PropTypes.func,

    successGlyphicon: React.PropTypes.string,
    warningGlyphicon: React.PropTypes.string,
    errorGlyphicon: React.PropTypes.string,

    labelColWidth: React.PropTypes.oneOfType([
      React.PropTypes.shape({
        xs: React.PropTypes.number,
        sm: React.PropTypes.number,
        md: React.PropTypes.number,
        lg: React.PropTypes.number
      }),
      React.PropTypes.string
    ]),
    inputColWidth: React.PropTypes.oneOfType([
      React.PropTypes.shape({
        xs: React.PropTypes.number,
        sm: React.PropTypes.number,
        md: React.PropTypes.number,
        lg: React.PropTypes.number
      }),
      React.PropTypes.string
    ]),

    inputAttrs: React.PropTypes.object
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      label: null,
      message: null,
      feedback: INITIAL_FEEDBACK,
      readOnly: false,
      size: 'md',
      onChange: null,
      onValidate: null,
      successGlyphicon: 'uu-glyphicon-ok-circle',
      warningGlyphicon: 'uu-glyphicon-alert-circle',
      errorGlyphicon: 'uu-glyphicon-error-circle',
      labelColWidth: 'xs-12 sm-3',
      inputColWidth: 'xs-12 sm-9',
      inputAttrs: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    return {
      message: this.props.message,
      feedback: this.props.feedback,
      value: this.props.value,
      readOnly: this.props.readOnly
    };
  },

  componentDidMount: function () {
    var parentForm = this._getForm();
    parentForm && parentForm.registerFormControl(this.getId(), this);
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.id && nextProps.id !== this.props.id) {
      var parentForm = this._getForm();
      if (parentForm) {
        parentForm.unregisterFormControl(this.props.id);
        parentForm.registerFormControl(nextProps.id, this);
      }
    }
    if (nextProps.controlled) {
      //TODO: jine komponenty jak text zkontrolovat willRecievePros (byude se modifikovat jen value), vsude musi byt nextProps.controled
      this.setFeedback(nextProps.feedback, nextProps.message, nextProps.value);
      this.setState({ readOnly: nextProps.readOnly })
    }
  },

  componentWillUnmount: function () {
    var parentForm = this._getForm();
    parentForm && parentForm.unregisterFormControl(this.getId());
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  isInput() {
    return true;
  },

  getValue() {
    let value;
    if (typeof this.getValue_ === 'function') {
      value = this.getValue_();
    } else {
      value = this.state.value;
    }
    return value;
  },

  setValue(value, setStateCallback) {
    if (typeof this.setValue_ === 'function') {
      this.setValue_(value, setStateCallback);
    } else {
      this.setState({ value: value || '' }, setStateCallback);
    }
    return this;
  },

  getMessage() {
    let message;
    if (typeof this.getMessage_ === 'function') {
      message = this.getMessage_();
    } else {
      message = this.state.message;
    }
    return message;
  },

  setMessage(message, setStateCallback) {
    if (typeof this.setMessage_ === 'function') {
      this.setMessage_(message, setStateCallback);
    } else {
      this.setState({ message: message }, setStateCallback);
    }
    return this;
  },

  getFeedback(){
    let feedback;
    if (typeof this.getFeedback_ === 'function') {
      feedback = this.getFeedback_();
    } else {
      feedback = this.state.feedback;
    }
    return feedback;
  },

  setFeedback(feedback, message, value, setStateCallback){
    if (typeof this.setFeedback_ === 'function') {
      this.setFeedback_(feedback, message, value, setStateCallback);
    } else {
      this.setState({
        feedback: feedback,
        message: message,
        value: value || ''
      }, setStateCallback);
    }
    return this;
  },

  setInitial(message, value, setStateCallback){
    if (typeof this.setInitial_ === 'function') {
      this.setInitial_(message, value, setStateCallback);
    } else {
      this._setFeedback(INITIAL_FEEDBACK, message, value, setStateCallback);
    }
    return this;
  },

  isInitial(){
    return this.getFeedback() === INITIAL_FEEDBACK;
  },

  setLoading(message, value, setStateCallback){
    if (typeof this.setLoading_ === 'function') {
      this.setLoading_(message, value, setStateCallback);
    } else {
      this._setFeedback(LOADING_FEEDBACK, message, value, setStateCallback);
    }
    return this;
  },

  isLoading(){
    return this.getFeedback() === LOADING_FEEDBACK;
  },

  setSuccess(message, value, setStateCallback){
    if (typeof this.setSuccess_ === 'function') {
      this.setSuccess_(message, value, setStateCallback);
    } else {
      this._setFeedback(SUCCESS_FEEDBACK, message, value, setStateCallback);
    }
    return this;
  },

  isSuccess(){
    return this.getFeedback() === SUCCESS_FEEDBACK;
  },

  setWarning(message, value, setStateCallback){
    if (typeof this.setWarning_ === 'function') {
      this.setWarning_(message, value, setStateCallback);
    } else {
      this._setFeedback(WARNING_FEEDBACK, message, value, setStateCallback);
    }
    return this;
  },

  isWarning(){
    return this.getFeedback() === WARNING_FEEDBACK;
  },

  setError(message, value, setStateCallback){
    if (typeof this.setError_ === 'function') {
      this.setError_(message, value, setStateCallback);
    } else {
      this._setFeedback(ERROR_FEEDBACK, message, value, setStateCallback);
    }
    return this;
  },

  isError(){
    return this.getFeedback() === ERROR_FEEDBACK;
  },

  reset(setStateCallback){
    if (typeof this.reset_ === 'function') {
      this.reset_(setStateCallback);
    } else {
      this.setState({
        message: this.props.message,
        feedback: this.props.feedback,
        value: this.props.value,
        readOnly: this.props.readOnly
      }, setStateCallback);
    }
    return this;
  },

  //TODO getResetValues

  getChangeFeedback(opt){
    let result;

    if (typeof this.getChangeFeedback_ === 'function') {
      result = this.getChangeFeedback_(opt);
    } else {
      result = {
        feedback: opt.required ? SUCCESS_FEEDBACK : INITIAL_FEEDBACK,
        message: null,
        value: opt.value
      }
    }

    return result;
  },

  setChangeFeedback(opt, setStateCallback){
    let result;

    if (typeof this.setChangeFeedback_ === 'function') {
      result = this.setChangeFeedback_(opt, setStateCallback);
    } else {
      result = this.getChangeFeedback(opt);

      this.setState({
        feedback: result.feedback,
        message: result.message,
        value: result.value
      }, setStateCallback);
    }

    return this;
  },

  isReadOnly(){
    return this.state.readOnly;
  },

  setEditableValue(value, setStateCallback){
    if (typeof this.setEditableValue_ === 'function') {
      this.setEditableValue_(value, setStateCallback);
    } else {
      this.setState({ readOnly: !value }, setStateCallback);
    }
    return this;
  },

  readOnly(setStateCallback){
    if (typeof this.readOnly_ === 'function') {
      this.readOnly_(setStateCallback);
    } else {
      this.setEditableValue(false, setStateCallback);
    }
    return this;
  },

  editable(setStateCallback){
    if (typeof this.editable_ === 'function') {
      this.editable_(setStateCallback);
    } else {
      this.setEditableValue(true, setStateCallback);
    }
    return this;
  },

  getLabel(inputId){
    let result = null;
    if (this.props.label != null) {
      result = <Label {...this._getLabelProps(inputId)} />
    }
    return result;
  },

  getInputWrapper(children, buttons){
    return <InputWrapper {...this._getInputWrapperProps(children, buttons)} />;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getForm: function () {
    var form = null;
    var parent = this.getParent && this.getParent();
    while (parent) {
      if (typeof parent.isInput === 'function' && parent.isInput()) {
        break;
      } else if (typeof parent.isForm === 'function' && parent.isForm()) {
        form = parent;
        break;
      } else {
        parent = parent.getParent && parent.getParent();
      }
    }
    return form;
  },

  _setFeedback: function (feedback, message, value, setStateCallback) {
    if (typeof this.props.onChangeFeedback === 'function') {
      this.props.onChangeFeedback({
        feedback: feedback,
        message: message,
        value: value || '',
        callback: setStateCallback,
        component: this
      });
    } else {
      this.setFeedback(feedback, message, value, setStateCallback);
    }
    return this;
  },

  _buildColWidthClassName: function (colWidth) {
    var newBsColWidth = colWidth;

    if (typeof newBsColWidth === 'string') {
      var colWidthArray = newBsColWidth.split(' ');
      newBsColWidth = {};
      colWidthArray.forEach(function (colWidth) {
        var match = colWidth.match(/^(.*)-(\d+)$/);
        newBsColWidth[match[1]] = parseInt(match[2]);
      });
    }

    var sizeClassNames = [];
    var lowerWidth = 12;

    !newBsColWidth.xs && lowerWidth && (newBsColWidth.xs = lowerWidth);
    (lowerWidth = newBsColWidth.xs) && sizeClassNames.push('col-xs-' + newBsColWidth.xs);
    !newBsColWidth.sm && lowerWidth && (newBsColWidth.sm = lowerWidth);
    (lowerWidth = newBsColWidth.sm) && sizeClassNames.push('col-sm-' + newBsColWidth.sm);
    !newBsColWidth.md && lowerWidth && (newBsColWidth.md = lowerWidth);
    (lowerWidth = newBsColWidth.md) && sizeClassNames.push('col-md-' + newBsColWidth.md);
    !newBsColWidth.lg && lowerWidth && (newBsColWidth.lg = lowerWidth);
    newBsColWidth.lg && sizeClassNames.push('col-lg-' + newBsColWidth.lg);

    return sizeClassNames.join(' ');
  },

  _getInputAttrs() {
    let mainAttrs = this.getMainAttrs();

    mainAttrs.className += ' ' + this.getClassName('main', 'UU5_Forms_InputMixin');
    mainAttrs.className += ' ' + this.getClassName('input', 'UU5_Forms_InputMixin') + this.props.size;
    mainAttrs.className += ' ' + this.getClassName('input', 'UU5_Forms_InputMixin') + this.state.feedback;
    if (this.isReadOnly()) {
      mainAttrs.className += ' ' + this.getClassName('readOnly', 'UU5_Forms_InputMixin');
    }

    if (this.state.feedback != INITIAL_FEEDBACK || this.props.required) {
      mainAttrs.className += ' ' + this.getClassName('hasGlyphicon', 'UU5_Forms_InputMixin');
    }

    return mainAttrs;
  },

  _getLabelProps(inputId){
    let className;
    if (this.props.labelPosition === 'right') {
      className = 'uu5-forms-input-label-right';
    }
    return {
      for: inputId,
      content: this.props.label,
      colWidth: this._buildColWidthClassName(this.props.labelColWidth),
      className: className
    }
  },

  _getInputWrapperProps(children, buttons) {

    let colWidth = this._buildColWidthClassName( this.props.label !== null ? this.props.inputColWidth : 'xs-12');
    let feedback = this.getFeedback();
    let message = this.getMessage();
    // if(this.props.labelPosition  && this.props.labelPosition !== 'left') {
    //   colWidth = this._buildColWidthClassName('xs-12');
    //   //feedback = null;
    //   //message = null;
    // }

    return {
      colWidth: colWidth,
      feedback: feedback,
      message: message,
      required: this.props.required,
      buttons: buttons,
      children: children,
      slider: this.getTagName() === 'UU5.Forms.Slider',
      datetime: this.getTagName() === 'UU5.Forms.Datetime'
    }
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  //@@viewOff:render
};

InputMixin.INITIAL_FEEDBACK = INITIAL_FEEDBACK;
InputMixin.SUCCESS_FEEDBACK = SUCCESS_FEEDBACK;
InputMixin.WARNING_FEEDBACK = WARNING_FEEDBACK;
InputMixin.ERROR_FEEDBACK = ERROR_FEEDBACK;
InputMixin.LOADING_FEEDBACK = LOADING_FEEDBACK;

export default InputMixin;



// WEBPACK FOOTER //
// ./forms/mixins/input-mixin.js